export const subwarehouseTypes = [
    { value: "medical", label: "Médico" },
    { value: "feed", label: "Alimento" },
    { value: "cleaning", label: "Limpieza" },
    { value: "supplies", label: "Insumos" },
];
